const activityBasedCategories = {
	AirTravel: 'Air Travel',
	ElectricityUsage: 'Electricity Usage',
	FuelUseOrPurchase: 'Fuel Use Or Purchase',
	HeatUsage: 'Heat Usage',
	SteamUsage: 'Steam Usage',
	OtherSpending: 'Other Spending',
	RailTravel: 'Rail Travel',
	RoadTravel: 'Road Travel',
	SeaTravel: 'Sea Travel',
	SelectedEmissionFactor: 'Selected Emission Factor',
	SpecifiedEmissions: 'Specified Emissions',
	TravelAccommodation: 'Travel Accommodation',
	TravelFood: 'Travel Food',
}

const spendBasedCategories = {
	'Agriculture/Hunting/Forestry/Fishing':
		'Agriculture\u00A0/ Hunting\u00A0/ Forestry\u00A0/ Fishing',
	'Arable Farming': 'Arable Farming',
	'Fishing/Aquaculture/Hunting': 'Fishing\u00A0/ Aquaculture\u00A0/ Hunting',
	'Livestock Farming': 'Livestock Farming',
	'Timber and Forestry Products': 'Timber and Forestry Products',
	'Construction Work': 'Construction Work',
	'Housing Rental': 'Housing Rental',
	'Pipeline Transport': 'Pipeline Transport',
	'Building Maintenance and Repair': 'Building Maintenance and Repair',
	'Pavement and Surfacing': 'Pavement and Surfacing',
	'Real Estate Services': 'Real Estate Services',
	'Clothing and Footwear': 'Clothing and Footwear',
	'Consumer Goods Rental': 'Consumer Goods Rental',
	'DIY and Gardening Equipment': 'DIY and Gardening Equipment',
	'Domestic Services': 'Domestic Services',
	'Furnishings and Household': 'Furnishings and Household',
	'General Retail': 'General Retail',
	'Health Store': 'Health Store',
	'Paper Products': 'Paper Products',
	'Personal Care and Accessories': 'Personal Care and Accessories',
	'Recreation and Culture': 'Recreation and Culture',
	'Textiles Consumer Goods': 'Textiles Consumer Goods',
	'Professional Services and Activities':
		'Professional Services and Activities',
	'Education Services': 'Education Services',
	'Energy Services': 'Energy Services',
	'Electrical Equipment': 'Electrical Equipment',
	'Electronics Products': 'Electronics Products',
	'Equipment Repair': 'Equipment Repair',
	'Machinery Equipment': 'Machinery Equipment',
	'Office Equipment': 'Office Equipment',
	'Financial Services': 'Financial Services',
	'Insurance Services': 'Insurance Services',
	'Land Use Change': 'Land Use Change',
	'Building Materials': 'Building Materials',
	'Ceramic Goods': 'Ceramic Goods',
	'Chemical Products': 'Chemical Products',
	'Fabricated Metal Products': 'Fabricated Metal Products',
	'Glass and Glass Products': 'Glass and Glass Products',
	'Manufactured Goods': 'Manufactured Goods',
	'Metals Products': 'Metals Products',
	'Mined Materials': 'Mined Materials',
	'Mining Products': 'Mining Products',
	'Organic Products': 'Organic Products',
	'Other Materials Products': 'Other Materials Products',
	'Paper and Cardboard': 'Paper and Cardboard',
	'Plastics and Rubber Products': 'Plastics and Rubber Products',
	'Textiles Materials and Manufacturing':
		'Textiles Materials and Manufacturing',
	'Vehicle Parts': 'Vehicle Parts',
	'Government Activities': 'Government Activities',
	'Non-profit Activities': 'Non-profit Activities',
	'Operational Activities': 'Operational Activities',
	'Organizational Activities': 'Organizational Activities',
	'Wholesale Trade': 'Wholesale Trade',
	'Refrigerants and Fugitive Gases': 'Refrigerants and Fugitive Gases',
	'Food and Beverage Services': 'Food and Beverage Services',
	'Air Freight': 'Air Freight',
	'Rail Freight': 'Rail Freight',
	'Road Freight': 'Road Freight',
	'Sea Freight': 'Sea Freight',
	'Transport Services and Warehousing': 'Transport Services and Warehousing',
	Vehicles: 'Vehicles',
	'Construction Waste': 'Construction Waste',
	'Electrical Waste': 'Electrical Waste',
	'Food and Organic Waste': 'Food and Organic Waste',
	'General Waste': 'General Waste',
	'Glass Waste': 'Glass Waste',
	'Metal Waste': 'Metal Waste',
	'Paper and Cardboard Waste': 'Paper and Cardboard Waste',
	'Plastic Waste': 'Plastic Waste',
	'Waste Management': 'Waste Management',
	'Waste Product': 'Waste Product',
	'Water Supply': 'Water Supply',
	'Water Treatment': 'Water Treatment',
	'Postal services': 'Postal services',
	'Telecommunication services': 'Telecommunication services',
	'Data processing and hosting': 'Data processing and hosting',
	'Software and SAAS': 'Software and SAAS',
	'Office machines equipment rental': 'Office machines equipment rental',
	'Construction equipment rental': 'Construction equipment rental',
	'Other equipment rental': 'Other equipment rental',
	'Hotel stay': 'Hotel stay',
	'Hotel services': 'Hotel services',
	'Vehicle maintenance and repair': 'Vehicle maintenance and repair',
	'Restaurant services': 'Restaurant services',
	'Beverage Products': 'Beverage Products',
	'Food Products': 'Food Products',
	'Tobacco Products': 'Tobacco Products',
}

export const categories = {
	...activityBasedCategories,
	...spendBasedCategories,
}
